import React from 'react';
import { ServiceConfig } from '../../utils/serviceKeys';
import About from './About'; // Assuming About.tsx is in the same directory

interface AboutContentProps {
  serviceConfig: ServiceConfig;
}

const AboutContent: React.FC<AboutContentProps> = ({ serviceConfig }) => {
  // You can fetch more detailed about content here if needed
  // For now, we'll reuse the main About component content
  return <About serviceConfig={serviceConfig} />;
};

export default AboutContent;
